// DO NOT MODIFY, this file is autogenerated by tools/build.ts
import { ɵzoneWrap } from '@angular/fire';
import {
  httpsCallable as _httpsCallable
} from 'rxfire/functions';

export const httpsCallableData = ɵzoneWrap(_httpsCallable, true);
